import { ErrorText } from "@songtradr-one/shared-frontend";

export const errorText: ErrorText = {
  default: {
    message: "Something went wrong. Please try again later",
  },
};
